import withSessionCacheRequest from '../decorators/withSessionCacheRequest';
import { API_CACHE_KEYS } from '../utils/cache/cacheStore';

import AjaxUtils from './ajaxUtils';

const FREE_TRIAL_CACHE_TTL_SECONDS = 600;

const addUserToFreeTrial = data => AjaxUtils.post(`${envConfig.PLATFORM_SERVER_URL}/v2/free-trials`, data, true);

const fetchUserFreeTrialEligibility = () => withSessionCacheRequest(API_CACHE_KEYS.USER_FREE_TRIAL_ELIGIBILITY_CACHE_KEY, FREE_TRIAL_CACHE_TTL_SECONDS, () => AjaxUtils.get(`${envConfig.PLATFORM_SERVER_URL}/v2/free-trials/eligible-free-trial`, true));

export {
  addUserToFreeTrial,
  fetchUserFreeTrialEligibility,
};
